var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"help-container"}},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('menu.contact')))]),_c('div',{staticClass:"help-page",domProps:{"innerHTML":_vm._s(_vm.helpPage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }